import React from "react";
import s from "./style.module.scss";

interface LoadingOverlayProps {
  isLoading: boolean;
}

export const LoadingOverlay = ({ isLoading }: LoadingOverlayProps) => {
  if (isLoading) {
    return <div className={s.loadingOverlay}></div>;
  }
  return null;
};
